import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenCloseArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 15,
	viewBox: "0 0 20 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.7234 0.627988C19.0911 0.627987 19.3949 0.893366 19.443 1.23769L19.4496 1.33341L19.4496 13.5645C19.4496 13.9541 19.1245 14.27 18.7234 14.27C18.3557 14.27 18.0519 14.0045 18.0038 13.6602L17.9972 13.5645L17.9972 1.33341C17.9972 0.943818 18.3223 0.627988 18.7234 0.627988ZM10.3933 2.3245L10.4636 2.24538C10.7214 1.99498 11.1249 1.97225 11.4092 2.17718L11.4906 2.24549L16.3288 6.9461C16.5865 7.19639 16.61 7.58803 16.3993 7.86418L16.3291 7.94328L11.4909 12.6494C11.2075 12.9251 10.7477 12.9253 10.4639 12.65C10.2059 12.3998 10.1822 12.0079 10.3929 11.7316L10.4632 11.6524L14.0564 8.15623L0.810204 8.15708C0.442544 8.15708 0.138704 7.89174 0.0906185 7.54741L0.0839857 7.45166C0.0839856 7.09462 0.357189 6.79947 0.711661 6.75273L0.810204 6.74624L14.069 6.74539L10.4635 3.24301C10.2057 2.99254 10.1823 2.60064 10.3933 2.3245Z",
		fill: "currentColor"
	})
});
export default SvgOpenCloseArrow;
